
const fetchData = async (postData) => {
    try {

        const formData = new URLSearchParams();

        for (const key in postData) {
            formData.append(key, postData[key]);
        }
        

        console.log(postData)

        const response = await fetch(postData.url , {
            method: 'POST',
            //mode: 'no-cors',
            //credentials: 'include',
            // headers: {
            //     'Content-Type': 'application/json',
            // },
            body: formData,
            cache: 'no-cache',
            redirect: 'follow',
            referrer: 'no-referrer',
        });
        const result = await response.json();
        return result;
    } catch (err) {
        console.error('Error fetching data:', err);
        let error = err;
        return false;
    }
};



export default fetchData;